import * as React from "react";
import { makeStyles, mergeClasses, Text } from "@fluentui/react-components";
import { ACTION_STATUS } from "../../../shared/constants";

const useStyles = makeStyles({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 10px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "1.4",
    whiteSpace: "nowrap",
  },
  pending: { backgroundColor: "var(--bg-tertiary, #F0F1F3)", color: "var(--text-tertiary, #6E747D)" },
  processing: { backgroundColor: "var(--color-info-bg, #EDF7FC)", color: "var(--color-info, #13A3E0)" },
  completed: { backgroundColor: "var(--color-success-bg, #F0FAF0)", color: "var(--color-success, #7ED956)" },
  failed: { backgroundColor: "var(--color-error-bg, #FFF0F0)", color: "var(--color-error, #FF5757)" },
  approval_required: { backgroundColor: "var(--color-warning-bg, #FFF8E6)", color: "var(--color-warning, #FFB500)" },
});

const STATUS_LABELS = {
  [ACTION_STATUS.PENDING]: "Pending",
  [ACTION_STATUS.PROCESSING]: "Processing...",
  [ACTION_STATUS.COMPLETED]: "Done",
  [ACTION_STATUS.FAILED]: "Failed",
  [ACTION_STATUS.APPROVAL_REQUIRED]: "Approval",
};

/**
 * Pill badge showing action status with semantic colors.
 * @param {{ status: string, label?: string }} props
 */
const StatusBadge = ({ status, label }) => {
  const styles = useStyles();
  const statusClass = styles[status] || styles.pending;

  return (
    <span className={mergeClasses(styles.badge, statusClass)}>
      <Text size={200} weight="semibold">
        {label || STATUS_LABELS[status] || status}
      </Text>
    </span>
  );
};

export default StatusBadge;
